export default function Pandas_Quiz() {
  return <div>Pandas_Quiz </div>;
}
